import React from 'react'

function FailedIcon({ color = 'currentColor', size = 20, ...rest }) {
    return (
        <svg {...rest} width={size} height={size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_6574_11024)">
                <path d="M7.00033 12.8327C10.222 12.8327 12.8337 10.221 12.8337 6.99935C12.8337 3.77769 10.222 1.16602 7.00033 1.16602C3.77866 1.16602 1.16699 3.77769 1.16699 6.99935C1.16699 10.221 3.77866 12.8327 7.00033 12.8327Z" stroke={color} stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M8.75 5.25L5.25 8.75" stroke={color} stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.25 5.25L8.75 8.75" stroke={color} stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_6574_11024">
                    <rect width={size} height={size} fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default FailedIcon
